import script from "./SettingsOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsOverlay.vue?vue&type=style&index=0&id=3bc89f4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bc89f4f"]])

export default __exports__